// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
{
	"aboId": "",
	"aboRhId": "",
	"brdy": "",
	"age":0,
	"brdyAddCode": "",
	"brdyAddName": "",
	"certType": 0,
	"certno": "",
	"conerAddCode": "",
	"conerAddName": "",
	"conerCertNo": "",
	"conerCertTypeId": "",
	"conerName": "",
	"conerRltsId": "",
	"conerTel": "",
	"createType": "",
	"edulBacdId": "",
	"emprAddCode": "",
	"emprAddName": "",
	"jobId": "",
	"lunrBrdy": "",
	"mrgState": "",
	"name": "",
	"naplAddCode": "",
	"naplAddName": "",
	"naty": 1,
	"ntlyId": "",
	"phrUnt": "",
	// "pointPhrTypeId" : 0,
	"restAddCode": "",
	"restAddName": "",
	"rhrAlgs": [
		{
			"aiseId": 0,
			"algsDese": "",
			"dataSource": 1,
			"type": 0
		}
	],
	"sex": "",
	"tel": "",
	"thrNot": ""
}
]

